import { ApiService, ApiServiceGetResponse } from '@services'
import { BattlePassBackend } from '@store'

export const getBattlePassApi = async (): Promise<
  ApiServiceGetResponse<BattlePassBackend>
> => {
  const { ok, data } = await ApiService.get({
    endpoint: '/api/v1/battlepass',
  })

  return { ok, data: data || null }
}
